<template>
  <v-card class="mx-6 recap-banner" flat>
    <div class="hide-mobile banner-cursor__recap" @click="openRecapModal">
      <div class="svg-container__recap">
        <img
          src="@/assets/recap/mainPageRecapBanner/recapBanner-part1.svg"
          class="recap-banner-svg-part1"
        />
        <img
          src="@/assets/recap/mainPageRecapBanner/recapBanner-part2.svg"
          class="recap-banner-svg-part2"
        />
        <img
          src="@/assets/recap/mainPageRecapBanner/recapBanner-part3.svg"
          class="recap-banner-svg-part3"
        />
        <img
          src="@/assets/recap/mainPageRecapBanner/recapBanner-part4.svg"
          class="recap-banner-svg-part4"
        />
      </div>
    </div>
    <div
      class="d-flex container__title__recap banner-cursor__recap"
      @click="openRecapModal"
    >
      <div class="d-flex flex-column mr-md-9" style="align-items: center">
        <span class="text-h6 font-weight-medium white--text">{{
          $i18next.t('message.banners.recap.title')
        }}</span>
        <span class="subtitle__recap white--text font-weight-regular">{{
          $i18next.t('message.banners.recap.subtitle')
        }}</span>
      </div>
    </div>
    <div class="hide-mobile banner-cursor__recap" @click="openRecapModal">
      <img
        src="@/assets/recap/mainPageRecapBanner/recapBanner-part5.svg"
        class="recap-banner-svg-part5"
      />
    </div>
    <div class="close-banner__recap">
      <v-icon color="white" size="20px" @click="handleClose">mdi-close</v-icon>
    </div>
  </v-card>
</template>

<script>
import Storage from '@/utils/Storage'

export default {
  name: 'MainPageRecapBanner',
  computed: {
    locale() {
      return this.$i18next.resolvedLanguage
    },
  },
  methods: {
    openRecapModal() {
      this.$emit('openRecapModal')
    },
    handleClose() {
      Storage.setItem('hasClosedRecapBanner', true)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.close-banner__recap {
  position: absolute;
  right: 8px;
  top: 4px;
}

.recap-banner {
  min-height: 90px;
  height: 90px;
  border-radius: 4px;
  background-color: #3f55ee !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
  overflow: hidden;
}

.subtitle__recap {
  font-size: 18px;
  color: #e1dbff;
}

.page-view {
  &__container.has-pre-content {
    grid-template-areas: 'header-mobile' 'pre-content' 'content' 'header' !important;
    grid-template-rows: auto auto 1fr auto !important;

    @media (min-width: 680px) {
      grid-template-areas: 'header' 'pre-content' 'content' !important;
      grid-template-rows: auto auto 1fr !important;
    }
  }
}

@media screen and (max-width: 1279px) {
  .hide-mobile {
    display: none !important;
  }

  .recap-banner {
    justify-content: center;
  }
}

@media screen and (max-width: 982px) {
  .container__title__recap {
    flex-direction: column;
  }

  .page-view__container.c.has-pre-content,
  .page-view__container.ac.has-pre-content {
    grid-template-rows: 75px auto calc(100vh - 249px) !important;
  }

  .recap-banner {
    height: unset;
  }
}

@media screen and (max-width: 679px) {
  .page-view__container.c.has-pre-content,
  .page-view__container.ac.has-pre-content {
    grid-template-rows: auto auto 1fr auto !important;
  }
}

@media screen and (max-width: 572px) {
  .recap-banner {
    padding: 20px 20px;
  }
}

.svg-container__recap {
  position: relative;
  width: 238px;
  height: 261px;
  @media (min-width: 1300px) {
    margin-left: 40px;
  }
  margin-left: 20px;
}

.recap-banner-svg-part1 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.recap-banner-svg-part2 {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.recap-banner-svg-part3 {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.recap-banner-svg-part4 {
  position: absolute;
  z-index: 2;
  top: 52%;
  left: 51%;
  transform: translate(-50%, -50%);
}

.recap-banner-svg-part5 {
  scale: 1.3;
  width: 156px;
  height: 359px;
}

.banner-cursor__recap {
  cursor: pointer;
}
</style>
